import { render, staticRenderFns } from "./PayServiceDetailFooter.vue?vue&type=template&id=2ec610f8&scoped=true&"
import script from "./PayServiceDetailFooter.vue?vue&type=script&lang=ts&"
export * from "./PayServiceDetailFooter.vue?vue&type=script&lang=ts&"
import style0 from "./PayServiceDetailFooter.vue?vue&type=style&index=0&id=2ec610f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec610f8",
  null
  
)

export default component.exports